import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";

import PieChat from "../../../components/charts/rechart/PieChat";
import { BarCharts } from "../../../components/charts/rechart/BarCharts";
import { MultiLineChart } from "../../../components/charts/rechart/MultiLineChart";
import { BarChartNoPadding } from "../../../components/charts/rechart/BarChartNoPadding";
import { DoubleBarCharts } from "../../../components/charts/rechart/DoubleBarCharts";
import Loader from "../../../components/Loader";
import { getCurrentFormattedDate } from "../../../../utils/dateFormatter";
import { fetchSellerDashboard } from "../../../../services/DashboardService";
import { useTranslation } from "react-i18next";


const SellerDashboard = () => {
    const { t } = useTranslation();
  const [dasboardData, setDasboardData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeOffers, setActiveOffers] = useState([]);
  const [adsPerformance, setAdsPerformance] = useState([]);
  useEffect(() => {
    getDasboardData();
  }, []);

  const getDasboardData = () => {
    const todayDate = getCurrentFormattedDate();

    fetchSellerDashboard({ from: "1970-01-01", to: todayDate })
      .then((res) => {
        const response = res?.data?.result;
        console.log(response);
        setDasboardData(response);

        const tempActiveOffers = response?.sellerprofilegraphs?.activeoffersperbusinessgraph;
        tempActiveOffers.push({ businessname: "Software Farm", numberofoffers: 5 });
        setActiveOffers(tempActiveOffers);

        const tempAdsPerformance = response?.sellerprofilegraphs?.adsperformancegraph;

        setAdsPerformance(tempAdsPerformance);

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const cardArray = [
    {
      icon: <Icon icon="simple-line-icons:list" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: dasboardData?.totalnumberofbusinesses ?? 0,
      title: t("hbusinessTotal"),
    },
    {
      icon: <Icon icon="dashicons:welcome-view-site" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: dasboardData?.totalnumberofadsclicks ?? 0,
      title: t("htotalads"),
    },
    {
      icon: <Icon icon="bxs:report" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: dasboardData?.sellerrate ?? 0,
      title: t("hsellerRate"),
    },
    {
      icon: <Icon icon="carbon:review" className="currency-icon p-2" fontSize={60} color="#EB8153" />,
      value: dasboardData?.totalnumberofreviews ?? 0,
      title: t("htotalreviews"),
    },
  ];
  return (
    <div>
      {loading && <Loader forProcess={true} />}
      <h2 className="mb-5">{t("sidebarItemDashboard")}</h2>

      {/* cards */}
      <div className="row">
        {cardArray?.map((item, index) => (
          <div className="col-xl-3 col-sm-6 px-2" key={index}>
            <div className="card card-coin ">
              <div className="card-body text-center">
                {item?.icon}
                <h2 className="text-black mb-2 font-w600">{item?.value}</h2>
                <p className="mb-0 fs-14">
                  {/* <span className="text-success me-1">45%</span> */}
                  {item?.title}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Business Graph */}
      <div className="d-flex gap-5">
        <div className="card card-coin w-50 ps-5 pt-3">
          <h3>{t("sidebarItemBusiness")}</h3>
          <div className="mx-auto ">
            <PieChat
              data={[
                {
                  name: t("hsold"),
                  count: dasboardData?.sellerprofilegraphs?.businessesstatusgraph?.numberofbusinessessold,
                },
                {
                  name: t("havailable"),
                  count: dasboardData?.sellerprofilegraphs?.businessesstatusgraph?.numberofbusinessesavailable,
                },
                {
                  name: t("pending"),
                  count: dasboardData?.sellerprofilegraphs?.businessesstatusgraph?.numberofbusinessespending,
                },
              ]}
              colors={["#10439F", "#EB8153", "#B4B4B8"]}
            />
          </div>
        </div>
        <div className="card card-coin w-50 px-5 py-3">
          <h3 className="mb-2">{t("hactiveOffer")}</h3>
          <div className="">
            <BarCharts data={activeOffers ?? []} color="#10439F" />
          </div>
        </div>
      </div>

      <div className="d-flex gap-5">
        <div className="card card-coin w-50 px-5 py-3">
          <h3 className="mb-2">{t("hnetprofit")}</h3>
          <div className="">
            <MultiLineChart data={adsPerformance ?? []} />
          </div>
        </div>
        <div className="card card-coin w-50 px-5 py-2">
          <h3 className="mb-4">{t("sidebarItemContracts")}</h3>
          <div className="">
            <BarChartNoPadding data={dasboardData?.sellerprofilegraphs?.contractsgraph} />
          </div>
        </div>
      </div>

      <div className="card card-coin px-5 py-2">
        <h3>{t("hadsperformance")}</h3>
        <div className="">
          <DoubleBarCharts data={dasboardData?.sellerprofilegraphs?.adsperformancegraph} />
        </div>
      </div>
    </div>
  );
};

export default SellerDashboard;
